var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.categoryName,"clearable":"","filterable":"","placeholder":_vm.$t('shared.pleaseSelectCode'),"loading":_vm.loading},on:{"change":_vm.change}},_vm._l((_vm.categories),function(item){return _c('el-option',{attrs:{"label":item,"value":item}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-150afb63","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/app/shared/components/categoryselector/CategorySelector.vue
// module id = i7TQ
// module chunks = 1